module.exports = __webpack_public_path__ + "img/img4.16e5e546.png";